import { ActivatedRoute, ActivatedRouteSnapshot } from "@angular/router";

export function getDataFromAncestorRoute(route: ActivatedRoute | ActivatedRouteSnapshot, key: string): any {
  let data;
  if (route instanceof ActivatedRoute) {
    data = route.snapshot.data[key];
  }

  if (route instanceof ActivatedRouteSnapshot) {
    data = route.data[key];
  }

  if (data != undefined) return data;
  if (!route.parent) return undefined;
  return getDataFromAncestorRoute(route.parent, key);
}

export function getParamFromAncestorRoute(route: ActivatedRoute | ActivatedRouteSnapshot, key: string): any {
  let data;
  if (route instanceof ActivatedRoute) {
    data = route.snapshot.params[key];
  }

  if (route instanceof ActivatedRouteSnapshot) {
    data = route.params[key];
  }

  if (data != undefined) return data;
  if (!route.parent) return undefined;
  return getParamFromAncestorRoute(route.parent, key);
}

export function getQueryParamFromAncestorRoute(route: ActivatedRoute | ActivatedRouteSnapshot, key: string): any {
  let data;
  if (route instanceof ActivatedRoute) {
    data = route.snapshot.queryParams[key];
  }

  if (route instanceof ActivatedRouteSnapshot) {
    data = route.queryParams[key];
  }

  if (data != undefined) return data;
  if (!route.parent) return undefined;
  return getParamFromAncestorRoute(route.parent, key);
}
